<template>
  <div v-if="show" :style="{ width, height }" :id="chartsId"></div>
</template>

<script>
// 引入 echarts 核心模块，核心模块提供了 echarts 使用必须要的接口。
import * as echarts from 'echarts/core';
// 引入柱状图图表，图表后缀都为 Chart
import { BarChart } from 'echarts/charts';
// 引入提示框，标题，直角坐标系，数据集，内置数据转换器组件，组件后缀都为 Component
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DatasetComponent,
  TransformComponent,
  DataZoomComponent,
  DataZoomSliderComponent
} from 'echarts/components';
// 标签自动布局、全局过渡动画等特性
import { LabelLayout, UniversalTransition } from 'echarts/features';
// 引入 Canvas 渲染器，注意引入 CanvasRenderer 或者 SVGRenderer 是必须的一步
import { CanvasRenderer } from 'echarts/renderers';

// 注册必须的组件
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  LegendComponent,
  TransformComponent,
  BarChart,
  LabelLayout,
  UniversalTransition,
  CanvasRenderer,
  DataZoomComponent,
  DataZoomSliderComponent
]);

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    chartsId: {
      type: String,
      default: 'charts'
    },
    data: {
      type: Array,
      default: () => []
    },
    show: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    myChart: ''
  }),
  mounted() {
    window.addEventListener('resize', this.resize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize);
  },
  watch: {
    data: {
      handler(data) {
        setTimeout(() => {
          if (data.length && this.show) this.initCharts(data);
        }, 200);
      },
      immediate: true
    },
    show(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.initCharts(this.data);
          }, 200);
        });
      }
    }
  },
  methods: {
    resize() {
      if (!this.myChart) return;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.myChart.resize();
      }, 200);
    },
    initCharts(data) {
      const maxMoney = data.reduce((a, b) => {
        return a.money > b.money ? a : b;
      }).money;
      const maxCnt = data.reduce((a, b) => {
        return a.cnt > b.cnt ? a : b;
      }).cnt;

      var mychartTag = echarts.getInstanceByDom(document.getElementById(this.chartsId));
      if (mychartTag == null) {
        this.myChart = echarts.init(document.getElementById(this.chartsId));
      }

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: { textStyle: {} },
        dataZoom: [
          {
            show: true,
            type: 'slider',
            startValue: 0,
            endValue: 5,
            filterMode: 'empty',
            width: '66%',
            height: 10,
            left: 'center',
            // 是否锁定选择区域（或叫做数据窗口）的大小
            brushSelect: false,
            zoomLock: true,
            // 控制手柄的尺寸
            handleSize: 0,
            bottom: 0
          },
          {
            type: 'inside',
            zoomOnMouseWheel: false,
            moveOnMouseMove: true,
            moveOnMouseWheel: true
          }
        ],
        grid: {
          top: 80,
          left: 40,
          right: 50,
          bottom: 30,
          containLabel: true
        },
        yAxis: [
          {
            type: 'value',
            name: '试件数量',
            axisLabel: { formatter: '{value}' },
            axisLine: {
              lineStyle: {}
            },
            min: 0,
            max: getTopNum(maxCnt, 5),
            splitLine: {
              lineStyle: {
                type: 'solid'
              }
            }
          },
          {
            type: 'value',
            name: '金额统计',
            axisLabel: { formatter: '{value} 元' },
            axisLine: { lineStyle: {} },
            min: 0,
            max: getTopNum(maxMoney, 5),
            splitLine: {
              lineStyle: {
                type: 'dashed'
              }
            }
          }
        ],
        xAxis: {
          type: 'category',
          inverse: true,
          nameGap: 40,
          data: data.map(item => item.testUserName),
          axisLabel: {}
        },
        series: [
          {
            name: '试件数量',
            data: data.map(item => item.cnt),
            type: 'bar',
            barCategoryGap: '50%'
          },
          {
            name: '金额统计',
            data: data.map(item => item.money),
            type: 'bar',
            yAxisIndex: 1,
            barCategoryGap: '50%',
            tooltip: {
              valueFormatter: function (value) {
                return value + '元';
              }
            }
          }
        ]
      };
      this.myChart.setOption(option);
    }
  }
};

export function getTopNum(maxNum, splitNumber) {
  return (parseInt(parseInt(maxNum / splitNumber) / 10) + 1) * splitNumber * 10;
}
</script>

<style lang="scss" scoped></style>
